// 审批状态枚举，针对注册、维修、访客申请的审批
export default {
    UNDER_APPROVAL: '00',
    PASS: '01',
    REJECT: '02',
    WITHDRAW: '03'
}
